module.exports = __webpack_public_path__ + "static/media/app-en.826bfec3.svg";